import React from 'react';
import InfoText from '../atoms/InfoText';
import classNames from 'classnames';

export default function SectionWrapper({
  title,
  subTitle,
  action,
  children,
  dataTestId,
  titleIcon,
  className,
}: {
  title: string;
  subTitle?: string;
  action?: React.ReactElement | boolean;
  children: React.ReactElement;
  dataTestId?: string;
  titleIcon?: React.ReactElement;
  className?: string;
}) {
  const headerTestId = dataTestId ? `${dataTestId}-header` : undefined;
  const titleStackTestId = dataTestId ? `${dataTestId}-title-stack` : undefined;
  const actionTestId = dataTestId ? `${dataTestId}-action` : undefined;
  const bodyTestId = dataTestId ? `${dataTestId}-body` : undefined;

  return (
    <div
      className={classNames(
        'p-6 rounded-xl border space-y-5 bg-white dark:border-gray-700',
        className
      )}
      data-testid={dataTestId}
    >
      <div
        className="flex items-center justify-between"
        data-testid={headerTestId}
      >
        <div className="space-y-1" data-testid={titleStackTestId}>
          <div className="flex items-center gap-1">
            {titleIcon}

            <InfoText
              text={title}
              className="!text-lg !text-light-text-primary !font-bold dark:!text-dark-text-primary"
              data-testid={dataTestId ? `${dataTestId}-heading` : undefined}
            />
          </div>
          {subTitle && (
            <InfoText
              text={subTitle}
              data-testid={dataTestId ? `${dataTestId}-subtitle` : undefined}
            />
          )}
        </div>

        {action != null && <div data-testid={actionTestId}>{action}</div>}
      </div>

      <div data-testid={bodyTestId}>{children}</div>
    </div>
  );
}
